<template>
    <div>
        <h5>{{title}}</h5>
        <div type="button" class="soup mdl-chip mdl-shadow--2dp" v-for="soup in soups" v-bind:key="soup.soupId"
             v-bind:class="{'mdl-color--accent': selectedSoup === soup.soupId, 'ordered': selectedSoup === soup.soupId}">
            <span class="mdl-chip__text" v-on:click="orderSoup(soup.soupId)">{{ soup.name }} <span v-if="soup.price !== 0">({{ soup.price }} Kč)</span></span>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */

    import axios from "axios"
    import config from "../config"

    export default {
        name: "SoupList",
        components: {},
        props: {
            title: String,
            soups: Array,
            selectedSoup: Number,
            forUser: String,
            day: String
        },
        methods: {
            orderSoup: function (id) {
                if(this.selectedSoup === id)
                    axios
                        .delete(config.host + "/v1/order/soup/" + this.forUser + "/" + this.day)
                        .then(response => {this.$emit('ordered-food')});

                else
                    axios
                        .post(config.host + "/v1/order/soup", { forUser: this.forUser, soupId: id })
                        .then(response => { this.$emit('ordered-food') });
            }
        }
    }
</script>

<style scoped>
    .soup {
        margin-left: .25rem;
        cursor: pointer;
    }

    .soup:hover {
        background: #666666;
        color: white;
    }

    .ordered {
        color: white;
    }
</style>